import React from "react";
import styles from "./Lines.module.css";

/**
 * Renders a string as-is, or an array of strings as explicit lines.
 *
 * A few labels are authored as separate text lines in the desktop frames but as
 * one line in the mobile frames, so the break is dropped on small screens.
 */
export default function Lines({ value }) {
  if (!Array.isArray(value)) return value;
  return value.map((line, i) => (
    <React.Fragment key={line}>
      {i > 0 && <br className={styles.br} />}
      {i > 0 && " "}
      {line}
    </React.Fragment>
  ));
}
